import Card from "../Styled/Dasboard/Card.jsx"

import {PureComponent} from "react"

import CardRow from "../Styled/Dasboard/CardRow.jsx"
import CardCol from "../Styled/Dasboard/CardCol.jsx"

import Link from "../../components/Link/Link.jsx"
import {Mail} from "react-feather"
import {Phone} from "react-feather"

import './Alert.scss'

export default class Alert extends PureComponent{
  render() {
    const {link, emailSelected, smsSelected, generate,} = this.props

    return (
      <Card className={`alert-card`} title={`Mes notifications`}>
        <CardRow>
          <CardCol className={`alert-card-col-checkboxes`}>
            <CardRow >
              <CardCol>
                <Mail/>
                <label>Mail</label>
                <input
                  checked={emailSelected}
                  type="checkbox"
                  readOnly={true}
                />
              </CardCol>

              <CardCol>
                <Phone/>
                <label>SMS</label>
                <input
                  checked={smsSelected}
                  type="checkbox"
                  readOnly={true}
                />
              </CardCol>
            </CardRow>
          </CardCol>

          <CardCol className="alert-card-cta-container">
            <Link
              className="btn btn-primary"
              to={generate({name: `${link.menu}.alertes`, parameters: link.parameters, search: link.search})}
            >
              Voir plus
            </Link>
          </CardCol>
        </CardRow>
      </Card>
    )
  }
}